// extracted by mini-css-extract-plugin
export default {"SectionOrderSummary":"SectionOrderSummary_SectionOrderSummary__UVSgn","NumberOfOrders":"SectionOrderSummary_NumberOfOrders__BWEXf","Wrapper":"SectionOrderSummary_Wrapper__XJChS"};